module.exports = __webpack_public_path__ + "img/EMT-GBM_GSE194329.e78edcb2.png";